import { z } from 'zod';
export const projectsAssistantContextCapability = 'projects.assistant-context.v1';
export const projectsAssistantContextProviderId = projectsAssistantContextCapability;
export const projectsAssistantContextSlot = 'platform.server.optional-context';
export const projectsAssistantContextRequestSchema = z.strictObject({
    requestId: z.string().uuid(),
    subjectType: z.literal('projects.project'),
    subjectId: z.string().uuid().nullable(),
    query: z.string().trim().max(160).nullable().optional(),
    requestedCapabilities: z.array(z.string()).min(1).max(50),
    redactionProfile: z.string().min(2).max(80),
    maxFacts: z.number().int().min(1).max(500),
});
//# sourceMappingURL=projects-assistant-context.contract.js.map